import _get from "lodash/get";
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import MVRContent from "./MVRContent";
import ProgressBar from "../../../components/ProgressBar";

export class MVRContainer extends React.Component {
    render() {
        return (
            <div>
                <Row>
                    <Col xs="12">
                        <ProgressBar percentage={80} />
                    </Col>
                    <Col xs="12">
                        <MVRContent />
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        business: _get(state, "appData.business", {})
    };
};
export default withRouter(
    connect(
        mapStateToProps,
        {}
    )(MVRContainer)
);
